import React, { useEffect, useState } from 'react';
import { BusyIndicator, Title } from '@sba/design-system';
import useIsCommunityPlan from '../composer/hooks/useIsCommunityPlan';
import useIsDeprecatedPlan from '../composer/hooks/useIsDeprecatedPlan';
import useLobbyBypass from '../composer/hooks/useLobbyBypass';
import AppsList from './AppsList';
import DeprecationNoticeDialog from './DeprecationNoticeDialog';
import { hasShownDeprecationNoticeToday, markDeprecationNoticeShownToday } from '../deprecation/deprecationNotice';
import searchIconImageUrl from './images/search.svg';
import useLobbyUrl from '../composer/hooks/useLobbyUrl';
import useIsFeatureEnabled from '../composer/hooks/useIsFeatureEnabled';

// NOTE: This is an import from the old Rails based apps listing view, and it assumes the same CSS classes
export default function AppsListView() {
  const [search, setSearch] = useState('');

  const lobbyBypass = useLobbyBypass();
  const isCommunityPlan = useIsCommunityPlan();
  const showDeprecationNotice = useIsDeprecatedPlan();
  const [deprecationDialogOpen, setDeprecationDialogOpen] = useState(false);

  useEffect(() => {
    if (showDeprecationNotice === true && !hasShownDeprecationNoticeToday()) {
      setDeprecationDialogOpen(true);
    }
  }, [showDeprecationNotice]);
  const lobbyUrl = useLobbyUrl();
  const isAppListingAllowed = useIsFeatureEnabled('allowProjectListView');

  if (!lobbyBypass && !isCommunityPlan && !isAppListingAllowed && lobbyUrl) {
    window.open(lobbyUrl, '_self');
    return (
      <div style={{ textAlign: 'center', marginTop: 50, display: 'flex', gap: 30, flexDirection: 'column' }}>
        <Title>Taking you to SAP Build Lobby</Title>
        <BusyIndicator delay={100} active size="L" />
      </div>
    );
  }

  // creation/deletion/copy should be enabled only when lobby_bypass or plan=community
  const canManageApps = lobbyBypass || isCommunityPlan;

  return (
    <div className="app_index row">
      <DeprecationNoticeDialog
        open={deprecationDialogOpen}
        onClose={() => {
          markDeprecationNoticeShownToday();
          setDeprecationDialogOpen(false);
        }}
      />
      <div className="app_index__header">
        <h1>My apps</h1>

        <div className="app_index__search_container">
          <img alt="Search" src={searchIconImageUrl} />
          <input
            type="text"
            className="app_index__search form_input"
            placeholder="Search"
            value={search}
            onChange={(event) => setSearch(event.currentTarget.value)}
          />
        </div>
        {canManageApps && (
          <div className="app_index__controls">
            <a href="/builder/applications/new" className="button button--green--solid">
              Create new
            </a>
          </div>
        )}
      </div>
      <AppsList search={search} canManageApps={canManageApps} />
    </div>
  );
}
